import React, { useState, useCallback, useEffect, Children, cloneElement } from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'

// components
import { ParagraphSmallCaps } from 'components/Paragraphs'

// icon
import { TriangleVertical } from 'components/ui/icons/Triangle'

// top bar dropdowns are white
const themeSelectSimpleWhite = (theme) => {
  return {
    button: {
      color: theme.blueElectric,
      backgroundColor: theme.white
    }
  }
}

// temporary
const Container = styled.div(({ menuFullWidth }) => css`
  position: ${menuFullWidth ? 'static' : 'relative'};
`)

const TriangleStyled = styled(TriangleVertical)`
  margin: 0 8px;
`

const buttonHeight = 60
const Button = styled(ParagraphSmallCaps)(({ theme, isActive, customTheme }) => ({
  cursor: 'pointer',
  height: buttonHeight,
  display: 'flex',
  alignItems: 'center',
  padding: '0 20px',
  backgroundColor: isActive ? theme.white : theme.blueMedium,
  color: isActive ? theme.blueElectric : theme.white,
  ...(customTheme && customTheme(theme, isActive).button)
}))

const Menu = styled.div(({ theme, isActive, menuDown, menuFullWidth }) => css`
  background-color: ${theme.white};
  border-radius: ${menuDown ? '0 0 2px 2px' : '2px 2px 0 0'};
  display: ${isActive ? 'block' : 'none'};  
  position: absolute;
  z-index: 20;
  left: 0;
  border-top: ${menuFullWidth && menuDown ? `1px solid ${theme.separator}` : 'none'};
  width: ${menuFullWidth ? '100%' : 'auto'};
  top: ${menuDown ? buttonHeight + 'px' : 'auto'};
  bottom: ${menuDown ? 'auto' : buttonHeight + 'px'};
`)

// default theme has blue background
const SelectSimple = ({ menuContent, buttonContent, menuDown, menuFullWidth, customTheme }) => {
  const [isMenuOpen, setMenuOpen] = useState(false)

  const toggleMenu = useCallback(() => {
    setMenuOpen(!isMenuOpen)
  }, [isMenuOpen])

  const closeMenu = useCallback(() => {
    setMenuOpen(false)
  }, [])

  useEffect(() => {
    const onOutsideClick = () => setMenuOpen(false)
    if (isMenuOpen) window.addEventListener('click', onOutsideClick)
    return () => window.removeEventListener('click', onOutsideClick)
  }, [isMenuOpen])

  const stopPropagation = useCallback((e) => {
    e.stopPropagation()
  }, [])

  const menuContentWithProps = Children.map(menuContent, child =>
    cloneElement(child, { closeMenu })
  )

  return (
    <Container
      onClick={stopPropagation}
      menuFullWidth={menuFullWidth}
    >
      <Menu
        isActive={isMenuOpen}
        menuDown={menuDown}
        menuFullWidth={menuFullWidth}
      >
        {menuContentWithProps}
      </Menu>
      <Button
        isActive={isMenuOpen}
        onClick={toggleMenu}
        customTheme={customTheme}
      >
        {buttonContent}
        <TriangleStyled
          isActive={isMenuOpen}
        />
      </Button>
    </Container>
  )
}

export default SelectSimple
export { themeSelectSimpleWhite }
